<script>
import { mapGetters, mapMutations, mapState } from 'vuex'

export default {
  computed: {
    ...mapState('app', ['showCartDetails']),
    ...mapGetters('cart', ['breakdown']),
    ...mapGetters('cart/rooms', { cartRooms: 'isEmpty' }),
  },
  watch: {
    cartRooms(val) {
      if (val) this.hideCart()
    },
  },
  methods: {
    ...mapMutations('app', {
      showCart: 'SHOW_CART',
      hideCart: 'HIDE_CART',
    }),
    toggleCart() {
      if (this.showCartDetails) return this.hideCart()

      this.showCart()
    },
  },
}
</script>

<template>
  <div class="flex flex-wrap items-end -mx-3 py-3 md:py-0">
    <div class="w-1/2 md:hidden px-3">
      <div class="block leading-none md:hidden">
        <a class="cursor-pointer" @click="toggleCart">
          <span class="text-gold-500">
            <span class="text-md mr-1">{{
              breakdown.currency
            }}</span>
            <span class="font-medium text-3xl">
              {{ breakdown.gross | currency }}
            </span>
          </span>
          <span class="text-sm text-blue-500 block hover:underline">
            {{ showCartDetails ? 'Hide details' : 'View details' }}
          </span>
        </a>
      </div>
    </div>

    <div class="w-1/2 md:w-full px-3">
      <div class="flex flex-row justify-end items-end text-left md:text-right">
        <div class="hidden leading-none md:block">
          <a class="cursor-pointer" @click="toggleCart">
            <span class="text-gold-500">
              <span class="text-md mr-1">{{
                breakdown.currency
              }}</span>
              <span class="font-medium text-3xl">
                {{ breakdown.gross | currency }}
              </span>
            </span>
            <span class="text-sm text-blue-500 block hover:underline">
              {{ showCartDetails ? 'Hide details' : 'View details' }}
            </span>
          </a>
        </div>
        <BaseLink
          v-if="$route.name === 'property-landing'"
          class="btn btn-gold capitalize block md:ml-6"
          :to="{ name: 'property-extras', query: $route.query }"
        >
          Book now
        </BaseLink>
        <BaseLink
          v-if="$route.name === 'property-extras'"
          class="btn btn-gold capitalize block ml-6"
          :to="{ name: 'property-booking', query: $route.query }"
        >
          Continue
        </BaseLink>
      </div>
      <!-- cart detail -->
    </div>
  </div>
</template>
